import Skeleton from "react-loading-skeleton"
import { useMediaQuery } from "react-responsive"
import { isDesktopMediaQuery } from "../constants/constants"

const WalletSkeleton: React.FC = () => {
    const isDesktop = useMediaQuery(isDesktopMediaQuery);
    return (
        <div>
            <div className="card card-style">
                <div className="card-body d-flex flex-column">
                    <Skeleton height={25} width={225} />
                    <Skeleton height={40} width={50} className="mt-2" />
                    <Skeleton height={35} className="w-full btn btn-sm rounded-sm mt-3" />
                </div>
            </div>
            <div className="card card-style">
                <div className="card-body d-flex flex-column">
                <Skeleton height={25} width={225} />
                <Skeleton height={40} width={50} className="mt-2" />
                    {
                        Array.from({ length: 2 }).map((_, i) => (
                            <div key={i} className="mt-2 card border-gray-400 rounded-4 bg-gray-200 shadow-none mb-2">
                                <div className="card-body d-flex flex-column p-3">
                                    <Skeleton height={25} width={225} />
                                    <div className="d-flex">
                                        <Skeleton height={25} width={225} />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div>
                <Skeleton height={35} width={225} className="content rounded-4 mb-0" />
                <div className="card card-style mt-3">
                    <Skeleton className="card card-style mx-3 my-3 rounded-4" style={{ height: isDesktop ? '280px' : '180px', width: isDesktop ? '95%' : '91%' }} />
                </div>
            </div>
        </div>
    )
}

export default WalletSkeleton